import { render } from "./CmsWidgetDetails.vue?vue&type=template&id=5958fd8c&lang=html"
import script from "./CmsWidgetDetails.vue?vue&type=script&lang=js"
export * from "./CmsWidgetDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__